import { Component, Suspense } from 'react'
import { connect } from 'react-redux'
import PopupModal from './PopupModal'
import Modal from '.'
import Field from '../fields'
import { getNominative } from '../../common/utils'
import { history } from '../../store'

interface AddTeamMemberModalProps {
  createItem: (data: any) => void
  setFormField: (data: { key: string; value: any }) => void
  fetchList: (list: string) => void
  showToast: (options: { title: string }) => void
  fields: any // Replace 'any' with a specific type if available
  isOpen: boolean
  preferredPeopleNominative: string
  role: string | null
  features: any // Replace 'any' with a specific type if available
}

export class AddTeamMemberModal extends Component<AddTeamMemberModalProps> {
  handleSubmit = () => {
    // @ts-ignore
    const { createItem, setFormField, user } = this.props
    setFormField({
      key: 'home',
      value: user.home,
    })
    createItem({
      url: 'list/carers',
      onComplete: this.handleComplete,
    })
  }

  handleComplete = (user: any) => {
    const { fetchList, showToast } = this.props
    fetchList('carers')
    showToast({ title: 'Added a Team Member' })
    history.push(`/organisation/team/${user.id}/profile`)
  }

  render() {
    const {
      fields,
      isOpen,
      preferredPeopleNominative,
      role,
      features,
      ...formProps
    } = this.props
    if (!fields || !isOpen) return null

    const ROLE_OPTIONS =
      role === 'carehome-admin' ? ROLE_OPTIONS_CAREHOME : ROLE_OPTIONS_GROUP

    const getFieldNote = () => ROLE_FIELD_NOTE()

    return (
      <PopupModal
        confirmText="Invite Team Member"
        title="Invite a new Team Member"
        buttonIcon="mail"
        buttonColour="success"
        list="Team Member"
        includesRequired
        onConfirm={this.handleSubmit}
        type="create"
        {...formProps}
      >
        <div style={{ marginBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys={['name.first', 'name.last']}
              label="Name"
              placeholders={['First', 'Last']}
              required
              type="multiText"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={{ marginBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="email-field"
              formId={MODAL_ID}
              inputType="email"
              keys="email"
              label="Email"
              note={EMAIL_FIELD_NOTE}
              required
              type="text"
              validationTypes="email"
              values={fields}
            />
          </Suspense>
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="role-field"
            formId={MODAL_ID}
            keys="role"
            label="Role"
            note={
              role === 'group-admin' ? ROLE_FIELD_NOTE_GROUP : getFieldNote()
            }
            supportLink={SUPPORT_LINK}
            options={ROLE_OPTIONS}
            required
            type="radios"
            values={fields}
          />
        </Suspense>
      </PopupModal>
    )
  }
}

const ROLE_OPTIONS_CAREHOME = [
  { label: 'Carer', value: 'carer' },
  { label: 'Senior Carer', value: 'senior-carer' },
  { label: 'Admin', value: 'carehome-admin' },
]

const ROLE_OPTIONS_GROUP = [
  { label: 'Group Admin', value: 'group-admin' },
  { label: 'Group Manager', value: 'group-manager' },
]

const MODAL_ID = 'addTeamMember'

const EMAIL_FIELD_NOTE = "This is where they'll get sent their login details."

const LEGACY_ROLE_FIELD_NOTE = (preferredPeopleNominative: string) =>
  `Carers can only access the Carer App, while Senior Carers also have limited access to the Care Office (viewing ${getNominative(
    preferredPeopleNominative,
    'Resident'
  )} and Report information only). Admins have full access to the Care Office. `

const ROLE_FIELD_NOTE = () =>
  `Carers can only access the Carer App
Senior Carers can access the app and limited Care Office access
Admins have full access to the Care Office and Carer App
Click on the blue question mark to find out more about these roles `

const ROLE_FIELD_NOTE_GROUP =
  'Group Admins are additionally able to invite and manage other team members.'
const SUPPORT_LINK =
  'https://support.logmycare.co.uk/en/articles/1541399-how-do-i-add-a-new-carer-senior-or-administrator'

const mapStateToProps = (state: any) => ({
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  role: state.global.user && state.global.user.role,
  features: state.global.home.features,
})

// @ts-ignore
const wrappedModal = connect(mapStateToProps, null)(AddTeamMemberModal)

export default Modal(wrappedModal, MODAL_ID)
